import { CHANGE_FCM_TOKEN } from "../actions/fcmToken";

export default function fcmToken(state = null, action) {
  switch (action.type) {
    case CHANGE_FCM_TOKEN:
      return action.fcmToken;

    default:
      return state;
  }
}
